import React, { useMemo } from "react";

import { TableLoader } from "./tableLoader";

const defaultProps = {
	tableProps: {
		header: {},
		body: {},
		footer: {},
	},
};
type Props = {
	loading: boolean;
	isHideFooterLoading: boolean;
	isHideHeaderLoading: boolean;
	variant: "table" | "input";
	children: any;
	tableProps?: typeof defaultProps.tableProps;
};

export const WithLoader = ({
	loading,
	isHideFooterLoading,
	isHideHeaderLoading,
	variant,
	children,
	tableProps = defaultProps.tableProps,
}: Props) => {
	const skeletonsMap = useMemo(
		() => ({
			table: (
				<TableLoader
					{...tableProps}
					isHideFooterLoading={isHideFooterLoading}
					isHideHeaderLoading={isHideHeaderLoading}
				/>
			),
			input: <> </>, // Extend
		}),
		[tableProps, isHideFooterLoading, isHideHeaderLoading],
	);

	var ChildrenWithLoader = useMemo(
		() => (loading ? skeletonsMap[variant] : children),
		[loading, skeletonsMap, variant, children],
	);

	return ChildrenWithLoader;
};
